import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Clock, MapPin, ArrowRight } from "lucide-react";
import { scrollTo } from "./Navbar";
import { whatsappHref } from "@/config";

const stat = (Icon, label) => (
  <div className="flex items-center gap-2 text-ax-sub text-sm">
    <Icon className="w-4 h-4 text-ax-cyan" /> {label}
  </div>
);

export const Hero = () => {
  return (
    <section className="relative overflow-hidden ax-grid">
      <div className="absolute inset-0 bg-gradient-to-b from-ax-bg/40 via-ax-bg/80 to-ax-bg" />
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-ax-orange/10 rounded-full blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-20 lg:pt-24 lg:pb-28 grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="inline-block font-mono text-xs uppercase tracking-widest px-3 py-1.5 rounded bg-ax-card text-ax-cyan border border-ax-border mb-6">
            Impressão &amp; Fabrico 3D · Portugal
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-ax-text">
            Da sua ideia à <span className="text-ax-orange">peça real</span>, com precisão industrial.
          </h1>
          <p className="mt-6 text-base sm:text-lg text-ax-sub max-w-xl leading-relaxed">
            Envie o seu ficheiro 3D e receba uma proposta avaliada caso a caso. Prototipagem
            rápida e produção de peças finais para indústria, manutenção e laboratórios.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("orcamento")}
              className="inline-flex items-center justify-center gap-2 bg-ax-orange hover:bg-ax-orangehover text-white font-semibold px-6 py-3.5 rounded-lg transition-all hover:scale-[1.03] hover:ax-glow"
            >
              Envie a sua ideia / ficheiro <ArrowRight className="w-4 h-4" />
            </button>
            <a
              data-testid="hero-cta-whatsapp"
              href={whatsappHref()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border border-ax-border hover:border-ax-cyan text-ax-text font-semibold px-6 py-3.5 rounded-lg transition-all hover:bg-ax-card"
            >
              Falar por WhatsApp
            </a>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3">
            {stat(Clock, "Resposta em < 2h úteis")}
            {stat(ShieldCheck, "Confidencialidade CAD garantida")}
            {stat(MapPin, "Produção 100% em Portugal")}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="relative"
        >
          <div className="rounded-2xl overflow-hidden border border-ax-border shadow-2xl shadow-black/50">
            <img
              src="https://images.pexels.com/photos/17716911/pexels-photo-17716911.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Impressora 3D industrial em produção"
              className="w-full h-[420px] object-cover"
            />
          </div>
          <div className="absolute -bottom-5 -left-5 bg-ax-card border border-ax-border rounded-xl px-5 py-4 shadow-xl hidden sm:block">
            <div className="font-mono text-xs text-ax-muted uppercase tracking-wider">Tecnologias</div>
            <div className="font-heading font-bold text-ax-text mt-1">FDM · SLA · SLS</div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
